import { Box, Container, Stack, SwipeableDrawer, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import BookIcon from '@mui/icons-material/Book';
import RexPlaylist from './RexPlaylist';
import CloseButton from '../../../components/CloseButton';
import SocialLinks from './SocialLinks';
import * as API from '../../../utils/APICalls'
import EPK from './EPK';
import Booking from './Booking';
import LoadingSpinner from '../../../components/LoadingSpinner';
import Events from './Events';

const MusicLander = () => {
  const [fade, setFade] = useState('fade-in');
  const { email } = useParams()
  const [showPlaylist, setShowPlaylist]
    = useState(false)
  const [showDrawer, setShowDrawer]
    = useState(false)
  const [showEPK, setShowEPK]
    = useState(false)
  const [showEvents, setShowEvents] = useState(false)
  const [artist, setArtist] = useState({})
  const artist_id = "66f5e536da93fc184974748c"

  const linkStyles = {
    fontSize: '2rem',
    fontFamily: 'Gilroy, sans-serif',
    fontWeight: 'bold',
    fontWeight: 'ExtraBold',
    cursor: 'pointer',
    margin: 0,
    // width: '85px'

  }
  const textStyles = {
    fontSize: '2rem',
    fontFamily: 'Gilroy, sans-serif',
    fontWeight: 'bold',
    fontWeight: 'ExtraBold',
    // width: '85px'

  }
  useEffect(() => {
    const fetchArtist = async () => {
      try {
        const result = await API.fetchArtist(artist_id)
        if (result) {
          //  console.log("[fetchArtist]:", result)
          // albs = []=result?.albums
          setArtist(result)
          //    setAlbums(albs)
          //  console.log("[fetchArtist] albums:", albs) 
          // setLoading(false)
        }
      } catch (err) { console.log(err) }
    }

    fetchArtist()

  }, [])

  useEffect(() => {
    setFade('fade-in'); // Trigger fade-in on mount
  }, []);
  if (!artist?._id) {
    return (
      <Container sx={{

        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        // flex:1,
        width: '100%', height: '100%', minHeight: '90vh',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        overflow: 'hidden',
        // border:'1px solid red'
      }}>
        <div style={{ alignSelf: 'center' }}>
          <LoadingSpinner />
        </div>
        Loading...
      </Container>
    )
  }
  else {
    return (
      <Container sx={{

        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        // flex:1,
        width: '100%', height: '100%', minHeight: '90vh',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        overflow: 'hidden',
        // border:'1px solid red'
      }}>
        <Box sx={{
          position: 'absolute',
          left: '45%',
          top: '0.5rem',
          transform: 'translate(-40%,0)',
          margin: '0.5rem auto',
          backgroundColor: '#FFF',

        }}
        >
          <SocialLinks artist={artist} size='lrg' />
        </Box>
        <Stack sx={{ gap: '2rem', justifyContent: 'center', margin: 'auto', width: '100%', height: 'fit-content' }}>

          <img //component='img'
            // src='/assets/RE_Music_Banner_sml.png'
            src='https://res.cloudinary.com/dzxzdsnha/image/upload/v1744818562/RE%20Branding/RE_Music_Banner_sml_fxgsvh.png'
            style={{
              width: '80%',
              maxWidth: '400px',
              height: 'auto',
              margin: 'auto'
            }}
          />


          <Box sx={{
            display: 'flex',
            width: '80%', height: '100%',
            // gap:'0.5rem',
            margin: 'auto',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            alignCOntent: 'center'
          }}
            className={fade}
          >
            <Stack onClick={() => {
              setShowDrawer(true)
              setShowEPK(false)
              setShowEvents(false)
              setShowPlaylist(true)
            }}
              className='blink'
              sx={{ textAlign: "center", gap: '0rem' }}>

              <Typography sx={{ ...linkStyles, textAlign: "right" }}

              >
                <b>
                  NEW
                </b>
              </Typography>
              <Typography sx={{ ...linkStyles, textAlign: "right" }}

              ><b>
                  ARRIVAL
                </b>
              </Typography>
            </Stack>

            <Stack sx={{ justifyContent: 'center' }}>
              <Typography sx={textStyles}>|</Typography>
              <Typography sx={{ ...textStyles, fontSize: '1.5rem' }}>or</Typography>
              <Typography sx={textStyles}>|</Typography>
            </Stack>

            {/* <Typography sx={{...linkStyles,textAlign:"left", }} className='blink-2'
            onClick={()=>{
                window.location.assign(`/rexplayer${email?'/'+email:''}`)
            }}
            >RETURNING EXPLORER</Typography>  */}
            <Stack onClick={() => {
              // window.location.assign(`/rexplayer${email?'/'+email:''}`)
              window.location.assign(`https://rexentropy.com/`)
            }}
              className='blink-2'
              sx={{ textAlign: "center", gap: '0rem' }}>

              <Typography sx={{ ...linkStyles, textAlign: "left" }}

              >
                <b>
                  RETURN
                </b>
              </Typography>
              <Typography sx={{ ...linkStyles, textAlign: "left" }}

              >
                <b>
                  EXPLORER
                </b>
              </Typography>
            </Stack>


          </Box>
          <Typography
            className='blink'
            sx={{
              ...linkStyles, textAlign: "center", alignSelf: 'center', margin: 'auto', marginTop: '2rem',//transform:'translate(-1rem,0%)'

            }}
            onClick={() => {
              setShowDrawer(true)
              setShowEPK(false)
              setShowPlaylist(false)
              setShowEvents(true)
            }}
          ><b>
              Shows & Events
            </b>
          </Typography>

        </Stack>

        <SwipeableDrawer
          onTouchStart={event => {
            event.nativeEvent.defaultMuiPrevented = true
          }}
          open={showDrawer}
          anchor={'bottom'}
          onClose={() => {
            setShowDrawer(false)
          }}
          sx={{
            display: 'flex', flex: 1,
            fontFamily: 'Gilroy,sans-serif',
            // maxWidth: '350px',
            padding: '0.5rem',

            maxHeight: '99%',
            minHeight: '90vh'
          }}
        >
          <Container sx={{
            position: 'relative',
            width: '100%', height: '100%',
            backgroundColor: 'rgba( 0, 0, 0, 0.6)',
            backgroundImage: 'url("/assets/BodyBG2.png")',
            // backgroundImage:'url("/assets/Gradient_01_Frame2.png")',
            backgroundAttachment: 'cover',
            backgroundRepeat: 'no-repeat',
            border: '2px solid #000',
            // margin:'auto',
            padding: '0.5rem',
            boxShadow: 'inset 0px 0px 60px 40px rgba(4, 16, 42, 0.6)',
            borderRadius: '5px', paddingTop: '1rem', overflow: 'hidden',
            overflowY: 'scroll', minHeight: '80vh'
          }}>
            <Box sx={{ position: 'absolute', top: '0rem', right: '0.5rem', zIndex: 99999999 }}>
              <CloseButton func={setShowDrawer} value={showDrawer}
              />
            </Box>
            {showPlaylist && <RexPlaylist sx={{ marginTop: '2rem' }} email={email} />}
            {showEPK && <Booking
              sx={{ marginTop: '2rem', }}
              artist={artist}
              setShowDrawer={setShowDrawer}
            />}
            {showEvents && <Events artist={artist} />}
          </Container>
        </SwipeableDrawer>

        {artist?._id && <Tooltip title=' EPK & Booking'>

          <span style={{//...textStyles,
            color: '#868686',
            display: 'flex',
            alignContent: 'center',
            aligntItems: 'center',
            position: 'absolute',
            bottom: "1.35rem", left: '50%', transform: 'translate(-50%,0%)',
            fontSize: '1.5rem', cursor: 'pointer'
          }}
            onClick={() => {
              if (artist) {

                setShowPlaylist(false)
                setShowEPK(true)
                setShowEvents(false)
                setShowDrawer(true)
              }
            }}
          ><>EPK &<BookIcon sx={{ fontSize: '2rem', alignSelf: 'baseline' }} />ing</></span>
        </Tooltip>}

        <div style={{
          margin: 'auto',
          // position: 'relative',
          position: 'absolute',
          bottom: "0rem", left: '50%', transform: 'translate(-50%,0%)',
          backgroundColor: '#FFF',
          color: '#000',
          height: '1rem',
          fontSize: '0.8rem',
          padding: '0.125rem',
          alignItems: 'center',
          textAlign: 'center'
        }} >
          {'© '}
          <a href="https://rexentropy.com" target="_blank">
            Rex Entropy LLC
          </a>{' 2023  - '}
          {new Date().getFullYear()}
          {'.'}
        </div>
      </Container>
    )
  }
}

export default MusicLander